import React, { Suspense, lazy } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import { ThemeProvider } from './context/ThemeContext';
import { PageLoader } from './components/common';
import ProtectedRoute from './components/auth/ProtectedRoute';

const LandingPage = lazy(() => import('./pages/landing/LandingPage'));
const LoginPage = lazy(() => import('./pages/auth/LoginPage'));
const RegisterPage = lazy(() => import('./pages/auth/RegisterPage'));
const ForgotPasswordPage = lazy(() => import('./pages/auth/ForgotPasswordPage'));
const ResetPasswordPage   = lazy(() => import('./pages/auth/ResetPasswordPage'));
const DashboardHome = lazy(() => import('./pages/dashboard/DashboardHome'));
const NotFoundPage = lazy(() => import('./pages/NotFoundPage'));
const DashboardLayout = lazy(() => import('./layouts/DashboardLayout'));
const ClientsPage = lazy(() => import('./components/dashboard/shared/ClientsPage'));
const UsersPage = lazy(() => import('./components/dashboard/shared/UsersPage'));
const PlansPage = lazy(() => import('./components/dashboard/shared/PlansPage'));
const WorkoutsPage = lazy(() => import('./components/dashboard/shared/WorkoutsPage'));
const DietsPage = lazy(() => import('./components/dashboard/shared/DietsPage'));
const TrackerPage = lazy(() => import('./components/dashboard/shared/TrackerPage'));
const SettingsPage = lazy(() => import('./components/dashboard/shared/SettingsPage'));
const LibraryPage = lazy(() => import('./components/dashboard/shared/LibraryPage'));
const StorePage = lazy(() => import('./components/dashboard/shared/StorePage'));
const CoachStorePage = lazy(() => import('./components/dashboard/shared/CoachStorePage'));
const RequestsPage = lazy(() => import('./components/dashboard/shared/RequestsPage'));
const ExerciseTutorialsPage = lazy(() => import('./components/dashboard/shared/ExerciseTutorialsPage'));
const WebsiteTutorialPage   = lazy(() => import('./components/dashboard/shared/WebsiteTutorialPage'));
const TransactionsPage      = lazy(() => import('./components/dashboard/shared/TransactionsPage'));

function App() {
  return (
    <ThemeProvider>
    <AuthProvider>
      <Router>
        <Suspense fallback={<PageLoader />}>
          <Routes>
            <Route path="/" element={<LandingPage />} />
            <Route path="/login" element={<LoginPage />} />
            <Route path="/register" element={<RegisterPage />} />
            <Route path="/forgot-password" element={<ForgotPasswordPage />} />
            <Route path="/reset-password" element={<ResetPasswordPage />} />
            <Route path="/dashboard" element={<ProtectedRoute><DashboardLayout /></ProtectedRoute>}>
              <Route index element={<DashboardHome />} />
              <Route path="clients" element={<ClientsPage />} />
              <Route path="users" element={<ProtectedRoute roles={['admin']}><UsersPage /></ProtectedRoute>} />
              <Route path="plans" element={<PlansPage />} />
              <Route path="requests" element={<ProtectedRoute roles={['admin']}><RequestsPage /></ProtectedRoute>} />
              <Route path="transactions" element={<ProtectedRoute roles={['admin']}><TransactionsPage /></ProtectedRoute>} />
              <Route path="workouts" element={<WorkoutsPage />} />
              <Route path="diets" element={<DietsPage />} />
              <Route path="tracker" element={<TrackerPage />} />
              <Route path="store" element={<StorePage />} />
              <Route path="coach-plans" element={<CoachStorePage />} />
              <Route path="library" element={<ProtectedRoute roles={['admin', 'coach']}><LibraryPage /></ProtectedRoute>} />
              <Route path="settings" element={<SettingsPage />} />
              <Route path="exercise-tutorials" element={<ExerciseTutorialsPage />} />
              <Route path="website-tutorial" element={<WebsiteTutorialPage />} />
            </Route>
            <Route path="/404" element={<NotFoundPage />} />
            <Route path="*" element={<Navigate to="/404" replace />} />
          </Routes>
        </Suspense>
      </Router>
    </AuthProvider>
    </ThemeProvider>
  );
}

export default App;